/**
 * Demographic options — mirror of
 * backend/nwd-backend/config/demographicOptions.js.
 *
 * The backend is authoritative: it validates every write against its own copy,
 * so a drift here shows up as a rejected field rather than as bad data. Keep
 * the two in step anyway.
 *
 * Replaces the old screens/Register/components/registerData.js.
 */

export const PREFER_NOT_TO_SAY = "Prefer not to say";

// --- Wave 1: asked inline on the registration form ---

export const ARRIVAL_REASONS = [
  "My days feel like they're passing me by",
  "I already reflect and want more structure",
  "I want a tool that treats my data decently",
  "Just curious",
  PREFER_NOT_TO_SAY,
];

export const JOURNAL_HABITS = [
  "Never",
  "I've tried and stopped",
  "Now and then",
  "Regularly",
  PREFER_NOT_TO_SAY,
];

// --- Wave 2: asked once the practice has returned something ---

export const AGE_BANDS = [
  "Under 18",
  "18–24",
  "25–34",
  "35–44",
  "45–54",
  "55–64",
  "65+",
  PREFER_NOT_TO_SAY,
];

export const WORK_CONTEXTS = [
  "Employed",
  "Self-employed or freelance",
  "Running a business",
  "Studying",
  "Caring for someone",
  "Retired",
  "Between things",
  PREFER_NOT_TO_SAY,
];

export const GENDERS = [
  "Woman",
  "Man",
  "Non-binary",
  "Self-describe or other",
  PREFER_NOT_TO_SAY,
];

export const EDUCATION_LEVELS = [
  "No formal qualifications",
  "Secondary school",
  "Further education or vocational",
  "Undergraduate degree",
  "Postgraduate degree",
  PREFER_NOT_TO_SAY,
];

export const COUNTRIES = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda",
  "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas",
  "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin",
  "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei",
  "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada",
  "Cape Verde", "Central African Republic", "Chad", "Chile", "China", "Colombia",
  "Comoros", "Congo", "Congo (DRC)", "Costa Rica", "Côte d'Ivoire", "Croatia",
  "Cuba", "Cyprus", "Czechia", "Denmark", "Djibouti", "Dominica",
  "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea",
  "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Fiji", "Finland", "France",
  "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada",
  "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras",
  "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland",
  "Israel", "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya",
  "Kiribati", "Kosovo", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon",
  "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg",
  "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta",
  "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia",
  "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique",
  "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand",
  "Nicaragua", "Niger", "Nigeria", "North Korea", "North Macedonia", "Norway",
  "Oman", "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea",
  "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania",
  "Russia", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia",
  "Saint Vincent and the Grenadines", "Samoa", "San Marino",
  "São Tomé and Príncipe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles",
  "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands",
  "Somalia", "South Africa", "South Korea", "South Sudan", "Spain",
  "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria",
  "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo",
  "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan",
  "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom",
  "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City",
  "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe",
  PREFER_NOT_TO_SAY,
];

/** The one sentence of purpose shown on both waves. */
export const DEMOGRAPHIC_PURPOSE =
  "So we can see who we're serving — and who we're missing. This never touches your journal.";

/**
 * True when the user has neither answered nor declined, so the Wave 2 card is
 * still worth showing. Undefined demographic (a pre-migration account) counts
 * as outstanding.
 */
export const demographicsOutstanding = (demographic) => {
  if (!demographic) return true;
  return !demographic.completedAt && !demographic.declined;
};
